export function getTableState(tableRef) {
    return tableRef.current
        ? tableRef.current.getResolvedState()
        : {}
}
export function cleanResolvedData(resolvedData) {
    if( !resolvedData )
        return []

    return resolvedData.map(({
        _original,
        _index,
        _subRows,
        _nestingLevel,
        ...resto
    }) => resto)
}
export function formatData(value,dataType='string',decimalDigits=2,currency="EUR",exponent=0,localeString='de-DE',emptyValue="-"){

    const exponentialNotationFactor = Math.pow(10, exponent);

    //INTEGER
    if(dataType === "integer"){       
        value =  parseFloat(value).toLocaleString(localeString,{ style:'decimal', minimumFractionDigits:0, maximumFractionDigits:0 })
    }

    //DECIMAL
    else if(dataType === "decimal"){ 
        value = parseFloat(value) / exponentialNotationFactor;
        if(isNaN(value))
            value = emptyValue;
        else
            value = value.toLocaleString(localeString,{ style:'decimal', minimumFractionDigits:decimalDigits, maximumFractionDigits:decimalDigits })
    }

    //PERCENT
    else if(dataType === "percent"){ 
        value = parseFloat(value)
        if(isNaN(value))
            value = emptyValue;
        else
            value = parseFloat(value).toLocaleString(localeString,{ style:'percent', minimumFractionDigits:decimalDigits, maximumFractionDigits:decimalDigits })
    }

    //STRING
    else if(dataType === "string"){
       
    }

    //DATE
    else if(dataType === "date"){
        
    }

    //CURRENCY
    else if(dataType === "currency"){
        value = parseFloat(value) / exponentialNotationFactor;
        if(isNaN(value))
            value = emptyValue;
        else
            value = value.toLocaleString(localeString,{ style:'currency', currency:currency, minimumFractionDigits:decimalDigits, maximumFractionDigits:decimalDigits })
    }
    
    if(!value)
        return emptyValue;

    return value
}
export function JSONToCSV(JSONData, ReportTitle = "CSV", ShowLabel = true, separator = ";", decimalSeparator = ",") {
    const arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData
    
    if (!arrData || arrData.length === 0) {
        alert("Dati non validi")
        return;
    }

    // --- 1. CALCOLO DINAMICO DELLE COLONNE ---
    // Invece di Object.keys(arrData[0]), scansioniamo TUTTI gli oggetti
    // per essere sicuri di non perdere campi che mancano nel primo record.
    const allKeys = new Set()
    arrData.forEach(obj => {
        Object.keys(obj).forEach(key => allKeys.add(key))
    });
    const columns = Array.from(allKeys)

    let csvRows = []

    // 2. INTESTAZIONE
    if (ShowLabel) {
        csvRows.push(columns.join(separator))
    }

    // 3. DATI (Basati sulla mappa 'columns' universale)
    for (let i = 0; i < arrData.length; i++) {
        const currentObj = arrData[i]
        
        const rowValues = columns.map(columnName => {
            let data = currentObj[columnName]

            // Gestione Valori Null, Undefined o Mancanti (Fix slittamento)
            if (data === null || data === undefined) {
                data = ""
            }

            // Gestione Numeri e Decimali
            const isNumeric = typeof data === 'number' || (
                typeof data === 'string' && data.trim() !== "" && !isNaN(data)
            )
            if (isNumeric) {
                // Convertiamo in stringa e sostituiamo il punto con la virgola (o il decimalSeparator scelto)
                data = String(data).replace(".", decimalSeparator)
            } else {
                // 3. Gestione Testo (Pulizia stringhe non numeriche)
                data = String(data).replace(/[\r\n]+/g, ' ').replace(/"/g, '""')
            }

            // PROTEZIONE COLONNE: Se il dato contiene il separatore (;) o virgolette, 
            // deve essere racchiuso tra virgolette per non rompere la struttura CSV
            const dataStr = String(data);
            if (dataStr.includes(separator) || dataStr.includes('"')) {
                data = `"${dataStr}"`;
            }

            return data
        })

        csvRows.push(rowValues.join(separator))
    }

    // Uniamo tutto con a capo standard e aggiungiamo il BOM (\uFEFF) per Excel
    const finalCSV = '\uFEFF' + csvRows.join('\r\n');

    // 4. DOWNLOAD
    const blob = new Blob([finalCSV], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    
    const date = new Date();
    const formattedDate = date.getFullYear() + '-' + 
                         ("0" + (date.getMonth() + 1)).slice(-2) + '-' + 
                         ("0" + date.getDate()).slice(-2) + '_' + 
                         date.getHours() + 'h' + 
                         date.getMinutes() + 'm' + 
                         date.getSeconds() + "s";

    link.setAttribute("href", url);
    link.setAttribute("download", `${ReportTitle.replace(/ /g, "_")}_${formattedDate}.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
export function rowObjectToRows( object ) {
    let rows = []
    Object.entries(object).map((row,index) => rows.push(row))

    return rows
}
export function niceField( field ) {
    field = field.charAt(0).toUpperCase() + field.slice(1)
    return field.replaceAll("_"," ").replaceAll("-"," ")
}